import { render, staticRenderFns } from "./filter-table.vue?vue&type=template&id=1b2996f0&scoped=true&"
import script from "./filter-table.vue?vue&type=script&lang=js&"
export * from "./filter-table.vue?vue&type=script&lang=js&"
import style0 from "./filter-table.vue?vue&type=style&index=0&id=1b2996f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2996f0",
  null
  
)

export default component.exports